import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import styles from './style.css';

const LoadingError = ({ errorMsg, suggestionMsg }) => {
  const refreshFeed = e => {
    e.preventDefault();
    window.location.reload();
  };

  return (
    <div className={styles.spinnerContainer}>
      <p>{errorMsg}</p>
      <p>
        <button className={styles.resetButton} onClick={refreshFeed}>
          {suggestionMsg}
        </button>
      </p>
    </div>
  );
};

LoadingError.propTypes = {
  errorMsg: PropTypes.string.isRequired,
  suggestionMsg: PropTypes.string.isRequired,
};

export default observer(LoadingError);



// WEBPACK FOOTER //
// ./src/components/loadingError/index.js